export default __webpack_public_path__ + "static/media/walmart.36d2b9fd.png";